module.exports = __webpack_public_path__ + "static/vip-d1d35401e4d89863cc00b6973beeb2c3.svg";